import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {SubscriptionInvoice} from '@app/domain/subscription-invoice';

/** Lo que el cliente contrató, lo que consume y lo que debe. */
export interface MiFacturacionResumen {
    razonSocial?: string;
    ruc?: string;
    tieneContrato?: boolean;
    periodicidad?: string;
    montoCiclo?: number;
    moneda?: string;
    montosIncluyenIgv?: boolean;
    contratoDesde?: Date;
    modalidadRecursos?: string;
    rucsUsados?: number;
    rucsContratados?: number;
    puntosVentaUsados?: number;
    puntosVentaContratados?: number;
    usuariosUsados?: number;
    usuariosContratados?: number;
    comprobantesEmitidos?: number;
    deudaTotal?: number;
    /** Lo emitido que todavía no vence. Separado del total a propósito. */
    deudaPorVencer?: number;
    deudaVencida?: number;
    facturasVencidas?: number;
    proximoVencimiento?: Date;
    proximoMonto?: number;
    diasDeAtraso?: number;
    /** NINGUNO | AVISO | URGENTE | CORTE_INMINENTE. Gobierna el tono del aviso. */
    nivelMora?: string;
    diasTolerancia?: number;
    diasParaCorte?: number;
    servicioActivo?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MiFacturacionService {

    baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    resumen(): Observable<MiFacturacionResumen> {
        return this.http.get<MiFacturacionResumen>(`${this.baseUrl}/mi-facturacion/resumen`);
    }

    facturas(): Observable<SubscriptionInvoice[]> {
        return this.http.get<SubscriptionInvoice[]>(`${this.baseUrl}/mi-facturacion/facturas`);
    }

    pagos(): Observable<any[]> {
        return this.http.get<any[]>(`${this.baseUrl}/mi-facturacion/pagos`);
    }
}
